import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useGoogleLogin } from "@react-oauth/google"; // ✅ Removed GoogleOAuthProvider from here
import axiosInstance from "../../axiosInstance";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();

  const validateForm = () => {
    if (!email.trim() || !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setError("Valid email is required.");
      return false;
    }
    if (!password.trim()) {
      setError("Password is required.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axiosInstance.post("/users/login", {
        email,
        password,
      });

      if (response.data.success) {
        if (response.data.data && response.data.data.status === "Login Successful") {
          localStorage.setItem("token", response.data.data.token);
          history.push("/");
        } else {
          setError("Please verify your email before logging in.");
        }
      } else {
        setError(response.data.error.message || "Login failed!");
      }
    } catch (err) {
      if (err.response?.data?.error?.message) {
        if (err.response.data.error.code === 401) {
          setError("Please verify your email before logging in.");
        } else {
          setError(err.response.data.error.message);
        }
      } else {
        setError("An error occurred during login.");
      }
    }
  };

  // ✅ Handle Google Login Success (Fetch Access Token)
  const handleGoogleSuccess = async (tokenResponse) => {
    console.log("Google Access Token:", tokenResponse.access_token);

    if (!tokenResponse.access_token) {
      setError("Google login failed. Please try again.");
      return;
    }

    try {
      const res = await axiosInstance.post(
        "/users/googleAuth",
        { code: tokenResponse.access_token }, // ✅ Send correct access token
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("API Response:", res.data);

      if (res.data.success) {
        localStorage.setItem("token", res.data.data.token);
        history.push("/");
      } else {
        setError("Google Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Google Login API Error:", error.response?.data || error);
      setError("Google Login failed. Please try again.");
    }
  };

  // ✅ Use `useGoogleLogin` to get the correct `access_token`
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      await handleGoogleSuccess(tokenResponse);
    },
    onError: () => setError("Google login failed. Please try again."),
    flow: "implicit", // ✅ Ensures we get an access_token
  });

  return (
    <Col md={5} className="p-5 bg-white full-height">
      <div className="login-main-left">
        <div className="text-center mb-5 login-main-left-header pt-4">
        <a href="https://autotrak.ai/">
          <img src="/img/logo-autotrak.png" className="img-fluid" alt="LOGO" />
        </a>
        </div>

        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          <div className="mt-4">
            <Row>
              <Col>
                <Button variant="outline-primary" size="lg" block type="submit">
                  Sign In
                </Button>
              </Col>
            </Row>
          </div>

         {/* ✅ Styled Google Login Button */}
          <div className="mt-3 text-center">
            <button
             onClick={() => login()}
            className="btn w-100 d-flex align-items-center justify-content-center py-2"
            style={{
              backgroundColor: "white",
              border: "1px solid #ddd",
              borderRadius: "5px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              fontSize: "16px",
              fontWeight: "500",
              color: "#333",
              position: "relative",
            }}
          >
            <img
              src="https://developers.google.com/identity/images/g-logo.png"
              alt="Google"
              style={{
                width: "20px",
                height: "20px",
                position: "absolute",
                left: "15px",
              }}
            />
            Sign in with Google
          </button>
          </div>

          <div className="mt-3 text-center">
            <p className="mb-0 text-left fpp">
              <Link to="/auth/forget-password" className="text-primary1">
                Forgot Password?
              </Link>
            </p>
          </div>

          {error && <p className="text-danger mt-3 text-center">{error}</p>}
        </Form>

        <div className="text-center mt-5">
          <p className="light-gray">
            Don’t have an account? <Link to="/auth/register">Sign Up</Link>
          </p>
        </div>
      </div>
    </Col>
  );
}

export default Login;
